import { Label } from "@/common/components/ui/label";
import { Slider } from "@/common/components/ui/slider";

export const CompactCalculatorRow = ({
  label,
  value,
  onChange,
  min,
  max,
  step = 1,
  prefix = "",
  suffix = "",
  limitLabels,
  readOnly = false,
  hideSlider = false,
  colorClass = "text-primary",
}: {
  label: string;
  value: number;
  onChange?: (val: number) => void;
  min?: number;
  max?: number;
  step?: number;
  prefix?: string;
  suffix?: string;
  limitLabels?: [string, string];
  readOnly?: boolean;
  hideSlider?: boolean;
  colorClass?: string;
}) => (
  <div className="space-y-4">
    <div className="group flex items-center justify-between">
      <Label className="text-lg font-bold text-secondary transition-colors group-hover:text-primary">
        {label}
      </Label>
      <div className="flex min-w-[140px] items-center justify-end gap-2 rounded-xl border border-slate-100 bg-slate-50 px-4 py-2 shadow-sm">
        {prefix && <span className="font-bold text-slate-400">{prefix}</span>}
        {readOnly ? (
          <span className={`font-black ${colorClass} text-xl`}>{value}</span>
        ) : (
          <input
            type="number"
            value={value}
            onChange={e => onChange?.(Number(e.target.value))}
            className={`w-24 border-none bg-transparent font-black focus:outline-none ${colorClass} text-right text-lg`}
          />
        )}
        {suffix && (
          <span className="ml-1 font-bold text-slate-400">{suffix}</span>
        )}
      </div>
    </div>

    {min !== undefined && max !== undefined && onChange && !hideSlider && (
      <div className="pt-2">
        <Slider
          value={[value]}
          onValueChange={v => onChange(v[0])}
          min={min}
          max={max}
          step={step}
          className="py-2"
        />
        {limitLabels && (
          <div className="mt-2 flex justify-between text-[10px] font-bold uppercase tracking-widest text-slate-400">
            <span>{limitLabels[0]}</span>
            <span>{limitLabels[1]}</span>
          </div>
        )}
      </div>
    )}
  </div>
);
